<template>
    <header-menu :onNavigate="scrollToSection" 
    
    > </header-menu>
    <fourth-section @close="dialog = false" :dialog="dialog"></fourth-section>
    <div class="onepage-wrapper">
     
      <first-section-kuhul  ref="whatNew"  @buyNow="dialog = true"  class="page-section">
      </first-section-kuhul>
      <second-section-kuhul   @buyNow="dialog = true" class="page-section">
      </second-section-kuhul>
      <third-section ref="about" class="page-section">
      </third-section>
    </div>
   

</template>
  
  
<script>
import FirstSection from "../components/FirstSection/FirstSection";
import SecondSection from "../components/FirstSection/SecondSection";
import ThirdSection from "../components/FirstSection/ThirdSection";
import FourthSection from "../components/FirstSection/FourthSection";
import HeaderMenu from "../components/FirstSection/HeaderMenu.vue";
import FirstSectionKuhul from "../components/FirstSection/FirstSectionKuhul.vue";
import SecondSectionKuhul from "../components/FirstSection/SecondSectionKuhul.vue";

  export default {
      name: "PrincipalPage",
      components: {
        FirstSectionKuhul,
        HeaderMenu,
        ThirdSection,
        SecondSectionKuhul,
        FourthSection
      },
      data: () => ({
        dialog: false,
      }),
      mounted() {
        const sections = document.querySelectorAll('.page-section')

        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible')
              }
            })
          },
          { threshold: 0.3 }
        )

        sections.forEach(section => observer.observe(section))
      },

      beforeUnmount() {
       
      },
      methods: {
        scrollToSection(section) {

          const map = {
            "what-new": this.$refs.whatNew,
            "about": this.$refs.about,
            "contact": this.$refs.contact
          };

          const el = map[section];

          if (!el) return;

          el.$el.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });

        }
      },
    };

</script>
<style>
.onepage-wrapper {
    height: 100vh;
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
}

.page-section {
    height: 100vh;
    scroll-snap-align: start;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}


@media (max-width: 1264px) {
  .onepage-wrapper {
    height: auto;
    overflow-y: visible;
    scroll-snap-type: none;
  }

  .page-section {
    height: auto;
    scroll-snap-align: none;
  }
}


</style>